"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStatisticalAggregator = createStatisticalAggregator;
var network_estimation_types_1 = require("../network-estimation-types");
var standard_deviation_aggregator_1 = require("./standard-deviation-aggregator");
function createStatisticalAggregator(logger, statisticalAggregatorConfig, getValueForAggregation, getDynamicMaxSampleAgeMs) {
    switch (statisticalAggregatorConfig.type) {
        case network_estimation_types_1.StatisticalAggregatorType.STANDARD_DEVIATION:
            return new standard_deviation_aggregator_1.StandardDeviationAggregator(logger, getValueForAggregation, getDynamicMaxSampleAgeMs, statisticalAggregatorConfig);
    }
}
